import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { ISetSearchParams } from 'components/core/types'
import Button from 'components/ui/abstract/Button'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { css, StyleSheet } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { AppDispatch } from 'components/store/state/store'
import { updateCurrentStep } from 'components/core/state/actions'
import constants from 'utils/constants'

const mapDispatch = (dispatch: AppDispatch) => ({
  updateStep: (step: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentStep(step, setSearchParams))
  },
})
const connector = connect(null, mapDispatch)

interface IBackButton extends ConnectedProps<typeof connector> {
  step: number,
}

const BackButton = ({ step, updateStep }: IBackButton) => {
  const { t } = useTranslation()
  const [, setSearchParams] = useSearchParams()
  const handleClick = () => updateStep(step, setSearchParams)
  return (
    <Button
      classes={{
        root: css(styles.button),
      }}
      startIcon={<ArrowBackIcon sx={{ fontSize: 24, color: constants.colors.green }} />}
      onClick={handleClick}
      variant="outlined"
      noArrow
    >
      <div className="tw-text-green">{t('back')}</div>
    </Button>
  )
}
const styles = StyleSheet.create({
  button: {
    border: 'none',
    color: constants.colors.green,
    fontSize: '13',
    marginLeft: '-14px',
    textDecoration: 'underline',
    textDecorationColor: constants.colors.green,
    textDecorationThickness: '2px',
    textUnderlineOffset: '4px',
  },
})
export default connector(BackButton)
